import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { LOGO_URL } from "@/data/site";
import { useContent } from "@/context/ContentProvider";

export default function Footer() {
  const { services, phones, phoneLinks } = useContent();

  return (
    <footer className="border-t border-amber-600/15 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <img src={LOGO_URL} alt="Crownvera Epoxy logo" className="h-20 w-auto mb-4 bg-stone-950 rounded-xl px-3 py-2 shadow-md" />
          <p className="text-sm text-stone-600 leading-relaxed max-w-xs">
            Northeast Ohio's premier metallic &amp; high-gloss epoxy flooring specialists. Garages, basements, patios, and workshops — poured like liquid gold.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-700 mb-4">Services</h4>
          <ul className="grid grid-cols-1 gap-2 text-sm text-stone-600">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="hover:text-amber-700 transition-colors duration-200">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-700 mb-4">Contact</h4>
          <div className="space-y-3 text-sm text-stone-700">
            {phones.map((p, i) => (
              <a key={p} href={phoneLinks[i]} data-testid={`footer-phone-${i + 1}`} className="flex items-center gap-2 hover:text-amber-700 transition-colors duration-200">
                <Phone className="w-4 h-4 text-amber-700" /> {p}
              </a>
            ))}
            <p className="flex items-center gap-2 text-stone-600">
              <MapPin className="w-4 h-4 text-amber-700" /> Cleveland, Ohio — Serving Northeast Ohio
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-amber-600/10 py-5 text-center text-xs text-stone-500">
        © {new Date().getFullYear()} Crownvera Epoxy · crownveraepoxy.com
      </div>
    </footer>
  );
}
